import { useSnackbar } from "notistack";
import React from "react";
import { ServiceHelper } from "@modules";
import { staffMenuPermissionService } from "@services/Settings";
import { DataTable } from "../Common";
import { DataTableColumn } from "../Common/DataTable/DataTable";
import { StaffMenuPermission } from "@interfaces/StaffMenuPermission";
import { useCurrentPageInfo, useModal } from "@hooks";

const StaffMenuPermissionTable = () => {
    const { permission } = useCurrentPageInfo();
    const { enqueueSnackbar } = useSnackbar();
    const { handleOpenModal } = useModal();

    const handleEditClick = (rowData) => {
        handleOpenModal("EDIT_STAFF_MENU_PERMISSION", { itemId: rowData.id });
    };

    const handleDeleteClick = async (rowData: StaffMenuPermission | StaffMenuPermission[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await staffMenuPermissionService.deletePermission(ids);
            enqueueSnackbar("Настройка успешно удалена", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении настройки", {
                variant: "error",
            });
        }
    };

    const columns: DataTableColumn<StaffMenuPermission>[] = [
        {
            title: "#",
            field: "id",
            defaultSort: "asc",
            width: 50,
        },
        {
            title: "Роль",
            field: "rolname",
            width: "auto",
        },
        {
            title: "Элемент меню",
            field: "menu_item",
            width: "auto",
        },
        {
            title: "Уровень доступа",
            field: "permission",
            width: "auto",
        },
    ];

    return (
        <DataTable
            fetchFn={staffMenuPermissionService.getPermissions}
            columns={columns}
            displayField="id"
            permission={permission}
            sorting
            search
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            // onMassDeleteClick={handleDeleteClick}
        />
    );
};

export default StaffMenuPermissionTable;
